/*=========================================================================================
  File Name: moduleKVDRMutations.js
  Description: KVDR module mutations
  ----------------------------------------------------------------------------------------
  Item Name: KVDR - key value driving role
  Author: Ashwani Bhardwaj
  Author Email: bhardwaj.ashwani92@gmail.com
==========================================================================================*/

// import axios from '@/axios.js';

export default {
  SET_KVDR(state,data){
    state.selectedKVDR = data;
  }
};
